export default "__VITE_ASSET__Rvm95uFs__"